module.exports = __webpack_public_path__ + "img/AramMohamad-rozhekLawSalana.372a919b.jpg";